(() => {
  'use strict';
  const root = document.querySelector('#MainContent [data-smagtron-audience-root][data-audience="private"]');
  if (!root) return;
  const products = JSON.parse(root.querySelector('[data-audience-products]').textContent);
  const eyebrow = root.querySelector('#sv5-hero-eyebrow');
  const title = root.querySelector('#sv5-hero-title');
  const description = root.querySelector('#sv5-hero-desc');
  const image = root.querySelector('#sv5-hero-image');
  const label = root.querySelector('#sv5-hero-label');
  const cta = root.querySelector('#sv5-hero-product');
  const buttons = [...root.querySelectorAll('[data-slide]')];
  // Capture the Liquid-rendered introduction before selecting any product.
  const intro = [
    'heater', eyebrow.textContent, title.innerHTML, description.textContent,
    label.textContent, cta.textContent
  ];
  const introHref = cta.getAttribute('href');
  const slideInfo = [
    intro,
    ['hare', 'Stromkasten-Design', 'Die weiße Tür.<br><span>Ihr Blickfang.</span>', 'Schwarzer Hase Blüten für die Stromkastentür. Motiv, Maße und Ausführung auf der Produktseite entdecken.', 'Stromkasten · Schwarzer Hase Blüten', 'Motiv entdecken →'],
    ['cat', 'Tonie-Figurenregal Katze', 'Die Hörspielwelt.<br><span>Ein eigener Platz.</span>', 'Ein Katzen-Nebenregal für Tonie-Figuren – ohne Toniebox-Plattform. Details und weitere Ausführungen im Shop.', 'Kinderzimmer · Figurenregal Katze', 'Figurenregal entdecken →'],
    ['clock', 'Motivuhren', 'Zeit für<br><span>Nordsee.</span>', 'Das Nordsee-Motiv für eine 30-cm-Wanduhr. Details und Varianten auf der Produktseite ansehen.', 'Motivuhr · Nordsee', 'Nordsee entdecken →']
  ];
  buttons.forEach(button => button.addEventListener('click', () => {
    const index = Number(button.dataset.slide);
    const slide = slideInfo[index];
    const product = products[slide[0]];
    eyebrow.textContent = slide[1];
    title.innerHTML = slide[2];
    description.textContent = slide[3];
    image.src = product.image;
    image.alt = product.alt;
    label.textContent = slide[4];
    if (index === 0) {
      // A scroll CTA is not a product/price initialization target.
      cta.removeAttribute('data-product');
      cta.setAttribute('href', introHref);
    } else {
      cta.dataset.product = slide[0];
      cta.href = product.href;
    }
    cta.textContent = slide[5];
    buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  }));

  // Keep the existing native range mapping and image-relative travel bounds.
  root.querySelectorAll('.smagtronAudience-compare-stage').forEach(stage => {
    const range = stage.querySelector('input');
    const update = () => {
      const fraction = (Number(range.value) - Number(range.min)) / (Number(range.max) - Number(range.min));
      const split = Number(stage.dataset.start) + fraction * (Number(stage.dataset.end) - Number(stage.dataset.start));
      stage.style.setProperty('--split', split + '%');
      range.setAttribute('aria-valuetext', Math.round(split) + ' Prozent Vorher-Ansicht');
    };
    range.addEventListener('input', update);
    update();
  });
})();
